// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__32A-L","options":"AnswerScale_options__B4aaw","selected":"AnswerScale_selected__1VK-M"};